import { FormControlLabel, InputAdornment, Switch } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import { showAlert } from 'actions/client';
import {
  fetchFatsomaPage,
  fetchManagedPages,
  updateVenue,
  uploadVenueImage,
} from 'actions/venue';
import ComboInputField from 'components/FormElements/ComboInputField';
import FormSelectField from 'components/FormElements/FormSelectField';
import FormSubmitButton from 'components/FormElements/FormSubmitButton';
import FormTextField from 'components/FormElements/FormTextField';
import QRDownloader from 'components/Utility/QRDownloader';
import LinkToPageTooltip from 'components/Utility/TooltipModal/LinkToPageTooltip';
import TabbFeesTooltip from 'components/Utility/TooltipModal/TabbFeesTooltip';
import URLPreview from 'components/Utility/URLPreview';
import * as Doka from 'libs/doka/doka.esm.min';
import 'libs/doka/doka.min.css';
import React from 'react';
import Loader from 'react-overlay-loader/lib/Loader';
import Pusher from 'react-pusher';
import { connect } from 'react-redux';
import { change, Field, getFormValues, reduxForm } from 'redux-form';
import styled from 'styled-components';
import placeholderSrc from 'utils/images/venue-image-placeholder.png';
import { APINetworkCall, callAPI } from 'utils/network';
import { Required } from 'utils/validators';
import { UpdateVenueAPIRequest } from '../../../../utils/constants/network';
import Checkbox from '../../Panels/MenuEditor/components/shared/Checkbox';
import AddButton from '../MenuEditor/components/shared/AddButton/index';
import CheckboxBeta from '../MenuEditor/components/shared/CheckboxBeta';
import EditButton from '../MenuEditor/components/shared/EditButton';
import AddPrinterDialog from './AddPrinterDialog';
import EditPrinterDialog from './EditPrinterDialog';
import './index.scss';
import ReceiptSettingsDialog from './ReceiptSettingsDialog';

const Container = styled.div`
  margin-top: 20px;
  margin-right: 20px;
  max-width: 900px;
  background-color: white;
  margin-bottom: 50px;
  border: 1px solid #ededed;
  border-radius: 11px;
  width: 100%;
  padding-bottom: 50px;
`;

const OrderContainer = styled.div`
  margin-top: 20px;
  margin-right: 20px;
  max-width: 900px;
  background-color: white;
  margin-bottom: 50px;
  border: 1px solid #ededed;
  border-radius: 11px;
  width: 100%;
  padding: 44px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-top: 51px;
  margin-left: 50px;
  margin-right: 20px;
  @media only screen and (max-width: 900px) {
    display: block;
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 30px;

  @media only screen and (max-width: 900px) {
    margin-left: 0px;
  }
`;
const FieldLabel = styled.label`
  font-family: 'Basier Circle';
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: -0.2px;
  color: #797979;
  margin-top: 30px;
  margin-bottom: -15px;
`;
const FieldDropdownLabel = styled.label`
  font-family: 'Basier Circle';
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: -0.2px;
  color: #797979;
  margin-top: 30px;
  margin-bottom: -30px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 10px;
`;

const TabbFeeURL = styled.div`
  font-size: 15px;
  @media (max-width: 480px) {
    font-size: 10px;
  }
`;
const ImageWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const StickyFooter = styled.div`
  position: sticky;
  bottom: 0;
  background-color: white;
  border-top: 1px solid #ededed;
  padding: 20px 50px;
  margin-top: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 15px;
  z-index: 100;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);

  @media only screen and (max-width: 900px) {
    padding: 15px 20px;
    justify-content: center;
  }
`;

const doka = Doka.create(null, {
  outputType: 'image/jpeg',
  outputQuality: 80,
  outputWidth: 500,
  outputHeight: 500,
});

class SettingsPanel extends React.Component {
  state = {
    venueImageSrc: null,
    fetchingPrinters: false,
    creatingTestPrintJob: false,
    updatingPrintStatus: false,
    printingEnabledToggleValue: false,
    addingPrinter: false,
    showReceiptSettings: false,
    printerToEdit: null,

    printDevices: [],
  };

  qrRef = React.createRef();

  componentWillMount() {
    this.setState({ printingEnabledToggleValue: this.props.printingEnabled });
    this.fetchPrintDevices();
    this.fetchFatsomaManagedPages();

    if (!this.props.venue.has_visited_settings) {
      const apiRequest = UpdateVenueAPIRequest({
        changes: { has_visited_settings: true },
      });
      callAPI(apiRequest);
    }
  }

  async fetchPrintDevices() {
    this.setState({ fetchingPrinters: true });

    const apiRequest = APINetworkCall.fromURL(
      `${process.env.REACT_APP_API_URL}/print/fetch-printers`
    );

    try {
      const { print_devices: printDevices } = await callAPI(apiRequest);
      this.setState({ printDevices });
    } catch (e) {
      console.error(e);
      this.props.showAlert(
        'Failure',
        'Sorry, we could not fetch the Print Devices. Please try again later.'
      );
    }

    this.setState({ fetchingPrinters: false });
  }

  async createTestPrint(printDeviceId) {
    this.setState({ creatingTestPrintJob: true });

    try {
      const apiRequest = APINetworkCall.fromURL(
        `${process.env.REACT_APP_API_URL}/print/create-test-print`,
        { print_device_id: printDeviceId }
      );
      await callAPI(apiRequest);

      this.props.showAlert(
        'Success',
        'We have sent a Test Job to this printer. Please allow a few seconds for the job to complete.'
      );
    } catch (e) {
      console.error(e);
      this.props.showAlert(
        'Failure',
        'Sorry, we could not create a test job for this printer.'
      );
    }

    this.setState({ creatingTestPrintJob: false });
  }

  handlePrintToggleChange(newValue) {
    this.setState({
      updatingPrintStatus: true,
      printingEnabledToggleValue: newValue,
    });
    this.props.updateVenue({ printing_enabled: newValue });
  }

  fetchFatsomaManagedPages(data = {}) {
    if (this.props.fatsomaPageConnected) {
      this.props.fetchFatsomaPage({ id: this.props.fatsomaPageId });
    } else {
      this.props.fetchManagedPages(data);
    }
  }

  queryFatsomaManagedPages(query) {
    if (!query || query.length < 2) {
      return;
    }

    if (this.props.managedPagesQueryable) {
      this.fetchFatsomaManagedPages({ query });
    }
  }

  existingFatsomaPage() {
    if (!this.props.fatsomaPageConnected) {
      return;
    }

    return (
      this.props.fatsomaPage || {
        id: this.props.fatsomaPageId,
        name: 'Connected',
      }
    );
  }

  render() {
    const {
      venueImageSrc,
      addingPrinter,
      printDevices,
      showReceiptSettings,
      printerToEdit,
    } = this.state;
    const { uploadingImage, venueImageUrl } = this.props;

    let activeVenueImageSrc = placeholderSrc;

    if (venueImageUrl) {
      activeVenueImageSrc = venueImageUrl;
    }

    if (venueImageSrc) {
      activeVenueImageSrc = venueImageSrc;
    }

    return (
      <React.Fragment>
        <div className="panel__content">
          <h2 className="panel__title">Venue Settings</h2>

          <Container>
            <ContentWrapper>
              <ImageWrapper>
                <div
                  className="settings__section__details__image__container"
                  style={{ borderRadius: '8px' }}
                >
                  <img src={activeVenueImageSrc} alt="" />
                  <input
                    id="myInput"
                    type="file"
                    ref={ref => (this.upload = ref)}
                    style={{ display: 'none' }}
                    onChange={this.onChangeFile.bind(this)}
                  />

                  <Button
                    onClick={() => this.upload.click()}
                    className="fatsoma__cta__secondary"
                  >
                    <Loader text="" loading={uploadingImage} />
                    Choose Venue Image
                  </Button>
                </div>
              </ImageWrapper>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <FormWrapper>
                  <Form autoComplete="off" autoCorrect="off" spellCheck="off">
                    <input type="hidden" value="prayer" />
                    <FieldLabel style={{ marginTop: 0 }}>Venue Name</FieldLabel>
                    <Field
                      style={{ fontWeight: 'normal' }}
                      className="settings__section__details__form__name"
                      name="name"
                      placeholder="My Venue"
                      fullWidth
                      autoCorrect="off"
                      spellCheck="off"
                      autoComplete="off"
                      type="text"
                      margin="normal"
                      component={FormTextField}
                      validate={[Required]}
                    />
                    <FieldLabel>Page URL</FieldLabel>
                    <Field
                      InputProps={{
                        startAdornment: (
                          <InputAdornment
                            className="settings__section__details__form__slug__adornment"
                            position="start"
                          >{`${process.env.REACT_APP_CUSTOMER_APP_URL}/venue/`}</InputAdornment>
                        ),
                      }}
                      className="settings__section__details__form__url"
                      name="url_slug"
                      placeholder="my-venue"
                      fullWidth
                      autoCorrect="off"
                      spellCheck="off"
                      autoComplete="off"
                      type="text"
                      margin="normal"
                      component={FormTextField}
                      validate={[Required]}
                    />
                    <a
                      href={`${process.env.REACT_APP_CUSTOMER_APP_URL}/venue/${this.props.url_slug}`}
                      className="fatsoma__cta_view"
                      style={{ marginTop: '25px' }}
                      target="blank"
                    >
                      {' '}
                      View Page
                    </a>

                    <FieldLabel>Venue Description</FieldLabel>
                    <Field
                      multiline
                      name="description"
                      placeholder="We offer..."
                      fullWidth
                      autoCorrect="off"
                      spellCheck="off"
                      autoComplete="off"
                      type="text"
                      margin="normal"
                      component={FormTextField}
                      validate={[Required]}
                    />
                    <FieldLabel>
                      Link With Fatsoma Page
                      <LinkToPageTooltip />
                    </FieldLabel>

                    <Field
                      name="fatsoma_page_id"
                      shrinkLabel={true}
                      component={ComboInputField}
                      items={this.props.managedPages}
                      isInputDisabled={
                        this.props.managedPages.length < 1 &&
                        !this.props.managedPagesQueryable
                      }
                      isItemDisabled={i => i.linked_to_venue}
                      isLoading={
                        this.props.fetchingManagedPages ||
                        this.props.fetchingFatsomaPage
                      }
                      forcedItem={this.existingFatsomaPage()}
                      noItemsMessage="No Available Pages"
                      noItemSelectedMessage="Select a page"
                      onInputEdit={v => this.queryFatsomaManagedPages(v)}
                    />

                    <FieldLabel style={{ marginBottom: 5 }}>
                      Fatsoma Tabb fee
                      <TabbFeesTooltip />
                    </FieldLabel>
                    <Wrapper>
                      <div>
                        <Field
                          color="primary"
                          label="Add fee to customer orders"
                          name="offset_fee_to_customer"
                          isChecked={
                            this.props.formValues.offset_fee_to_customer
                          }
                          onSelect={() => {
                            const toggle =
                              !this.props.formValues.offset_fee_to_customer;
                            this.props.changeFormField(
                              'venue-settings',
                              'offset_fee_to_customer',
                              toggle
                            );
                          }}
                          className="form__selector"
                          tall={true}
                          component={Checkbox}
                          style={{ fontSize: '13px', height: '35px' }}
                        />{' '}
                      </div>
                    </Wrapper>

                    <FieldDropdownLabel style={{ marginBottom: '5px' }}>
                      Pre-orders
                    </FieldDropdownLabel>
                    <Wrapper>
                      <Field
                        color="primary"
                        label="Accept Pre-orders"
                        name="accept_preorders"
                        isChecked={this.props.formValues.accept_preorders}
                        onSelect={() => {
                          const toggle =
                            !this.props.formValues.accept_preorders;
                          this.props.changeFormField(
                            'venue-settings',
                            'accept_preorders',
                            toggle
                          );
                        }}
                        className="form__selector"
                        tall={true}
                        component={Checkbox}
                        style={{ fontSize: '13px', height: '35px' }}
                      />
                    </Wrapper>

                    <Wrapper className="settings__section__details__tabb__fees__container">
                      <div className="fatsoma__fee__tooltip">
                        <FieldLabel>Clients</FieldLabel>
                      </div>
                      <div>
                        <Field
                          color="primary"
                          label="Enable Clients"
                          name="clients_enabled"
                          isChecked={this.props.formValues.clients_enabled}
                          onSelect={() => {
                            const toggle =
                              !this.props.formValues.clients_enabled;
                            this.props.changeFormField(
                              'venue-settings',
                              'clients_enabled',
                              toggle
                            );
                          }}
                          className="form__selector"
                          tall={true}
                          component={CheckboxBeta}
                          style={{ fontSize: '13px', height: '35px' }}
                        />{' '}
                      </div>
                    </Wrapper>

                    <div className="settings__section__details__tabb__fees__container">
                      <div className="fatsoma__fee__tooltip">
                        <FieldLabel>Multi-Venue</FieldLabel>
                      </div>
                      <Field
                        color="primary"
                        label="Enable Multi-Venue"
                        name="multi_venue_enabled"
                        isChecked={this.props.formValues.multi_venue_enabled}
                        onSelect={() => {
                          const toggle =
                            !this.props.formValues.multi_venue_enabled;
                          this.props.changeFormField(
                            'venue-settings',
                            'multi_venue_enabled',
                            toggle
                          );
                        }}
                        className="form__selector"
                        tall={true}
                        component={CheckboxBeta}
                        style={{
                          fontSize: '13px',
                          height: '35px',
                          marginBottom: '0px',
                        }}
                      />{' '}
                    </div>

                    <div className="settings__section__details__tabb__fees__container">
                      <div className="fatsoma__fee__tooltip">
                        <FieldLabel>VAT</FieldLabel>
                      </div>
                      <Field
                        color="primary"
                        label="Enable VAT"
                        name="enable_vat"
                        isChecked={this.props.formValues.enable_vat}
                        onSelect={() => {
                          const toggle = !this.props.formValues.enable_vat;
                          this.props.changeFormField(
                            'venue-settings',
                            'enable_vat',
                            toggle
                          );
                        }}
                        className="form__selector"
                        tall={true}
                        component={CheckboxBeta}
                        style={{
                          fontSize: '13px',
                          height: '35px',
                          marginBottom: '0px',
                        }}
                      />{' '}
                    </div>

                    {this.props.formValues.enable_vat && (
                      <div style={{ marginTop: 20 }}>
                        <FieldLabel>VAT Details</FieldLabel>
                        <Field
                          name="vat_number"
                          component={FormTextField}
                          label="VAT Number"
                          placeholder="e.g. GB123456789"
                          fullWidth
                        />
                        <Field
                          name="registered_business_name"
                          component={FormTextField}
                          label="Registered Business Name"
                          placeholder="e.g. Tabb Ltd"
                          fullWidth
                        />
                        <Field
                          name="registered_business_address"
                          component={FormTextField}
                          label="Registered Business Address"
                          placeholder="e.g. 123 High Street, London, EC1A 1BB"
                          fullWidth
                        />
                      </div>
                    )}
                  </Form>
                </FormWrapper>
              </div>
            </ContentWrapper>
          </Container>

          <div className="banner-wrapper-settings">
            <p className="settings-banner-text">
              Note: if you’re only taking reservations you can ignore the
              settings below
            </p>
          </div>

          <div>
            <h2 className="panel__title">Order & Pay</h2>
          </div>

          <OrderContainer>
            <form
              autoComplete="off"
              autoCorrect="off"
              spellCheck="off"
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                gap: '165px',
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {' '}
                <FieldDropdownLabel style={{ marginBottom: '5px' }}>
                  Pre-orders
                </FieldDropdownLabel>
                <div>
                  <Field
                    color="primary"
                    label="Accept Pre-orders"
                    name="accept_preorders"
                    isChecked={this.props.formValues.accept_preorders}
                    onSelect={() => {
                      const toggle = !this.props.formValues.accept_preorders;
                      this.props.changeFormField(
                        'venue-settings',
                        'accept_preorders',
                        toggle
                      );
                    }}
                    className="form__selector"
                    tall={true}
                    component={Checkbox}
                    style={{ fontSize: '13px', height: '35px' }}
                  />
                </div>
                <div className="settings__section__details__tabb__fees__container">
                  <div className="fatsoma__fee__tooltip">
                    <FieldLabel>Clients</FieldLabel>
                  </div>
                  <div>
                    <Field
                      color="primary"
                      label="Enable Clients"
                      name="clients_enabled"
                      isChecked={this.props.formValues.clients_enabled}
                      onSelect={() => {
                        const toggle = !this.props.formValues.clients_enabled;
                        this.props.changeFormField(
                          'venue-settings',
                          'clients_enabled',
                          toggle
                        );
                      }}
                      className="form__selector"
                      tall={true}
                      component={CheckboxBeta}
                      style={{ fontSize: '13px', height: '35px' }}
                    />{' '}
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {' '}
                <FieldDropdownLabel>Service Type</FieldDropdownLabel>
                <div style={{ width: 'auto' }}>
                  <Field
                    id="service_type"
                    name="service_type"
                    component={FormSelectField}
                    validate={[Required]}
                  >
                    <MenuItem
                      value="table_collection"
                      style={{ fontSize: '13px' }}
                    >
                      Table Service + Collection
                    </MenuItem>
                    <MenuItem value="collection">Collection Only</MenuItem>
                    <MenuItem value="table">Table Service Only</MenuItem>
                  </Field>
                </div>
                <div className="settings__section__details__tabb__fees__container">
                  <div className="fatsoma__fee__tooltip">
                    <FieldLabel>Multi-Venue</FieldLabel>
                  </div>
                  <Field
                    color="primary"
                    label="Enable Multi-Venue"
                    name="multi_venue_enabled"
                    isChecked={this.props.formValues.multi_venue_enabled}
                    onSelect={() => {
                      const toggle = !this.props.formValues.multi_venue_enabled;
                      this.props.changeFormField(
                        'venue-settings',
                        'multi_venue_enabled',
                        toggle
                      );
                    }}
                    className="form__selector"
                    tall={true}
                    component={CheckboxBeta}
                    style={{
                      fontSize: '13px',
                      height: '35px',
                      marginBottom: '0px',
                    }}
                  />{' '}
                </div>
                <FormSubmitButton
                  onClick={this.submit}
                  className="fatsoma__cta settings__section__details__form__cta"
                  loading={this.props.updatingVenue}
                  style={{ marginTop: '25px' }}
                >
                  Update
                </FormSubmitButton>
              </div>
            </form>
          </OrderContainer>

          <h2 className="panel__title">Your Tabb Page</h2>

          <div className="settings__section">
            <div className="settings__section__subheading">
              Link to your Tabb Page
            </div>
            <p>Copy the URL below to share it with your customers.</p>

            <div style={{ marginTop: 0, marginBottom: 35 }}>
              <URLPreview>
                <TabbFeeURL>{`${process.env.REACT_APP_CUSTOMER_APP_URL}/venue/${this.props.url_slug}`}</TabbFeeURL>
              </URLPreview>
            </div>

            <div className="settings__section__subheading">
              Download your QR Code
            </div>
            <p>
              Customers can view your Tabb page simply by scanning your QR code
              (below) with their phone’s camera. Give it a try yourself!
            </p>
            <p>
              There are links to download larger versions of your QR code in
              .SVG and .PNG formats, which can be printed out and placed in your
              venue.
            </p>

            <div style={{ marginTop: 20 }}>
              <QRDownloader
                url={`${process.env.REACT_APP_CUSTOMER_APP_URL}/venue/${this.props.url_slug}`}
              />
            </div>
          </div>

          <h2 className="panel__title">Receipt printers</h2>
          <div
            className="settings__section settings__section__padding__sm"
            style={{ position: 'relative' }}
          >
            <div
              className="settings__section__header__row"
              style={{ marginBottom: this.props.printingEnabled ? 24 : 0 }}
            >
              <FormControlLabel
                control={
                  <Switch
                    checked={this.state.printingEnabledToggleValue}
                    onChange={evt =>
                      this.handlePrintToggleChange(evt.target.checked)
                    }
                    color="primary"
                  />
                }
                label="Enable Printing"
              />

              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://intercom.help/tabb/en/articles/5188075-how-to-set-up-connect-your-printer"
              >
                Printer Connection Help
              </a>

              <Button
                onClick={() => this.setState({ showReceiptSettings: true })}
                className="fatsoma__cta printer__receipt__settings"
              >
                Receipt Settings
              </Button>

              {this.props.printingEnabled && (
                <div className="printer__section__seperator"></div>
              )}
            </div>

            {this.props.printingEnabled && (
              <div className="settings__section__printer">
                {printDevices && printDevices.length > 0 && (
                  <div className="table__container table__container__printers">
                    <table className="fold-table">
                      <thead>
                        <tr className="fold-table__header-row">
                          <th style={{ minWidth: 180 }}>Printer Name</th>
                          <th>Prep Area</th>
                          <th>Printer Status</th>
                          <th className="refund__table__header"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {printDevices.map((pd, index) => {
                          return (
                            <React.Fragment key={`print__list__${index}`}>
                              <tr
                                key={pd._id}
                                className={`view view__no__hover`}
                              >
                                <td className="td__booking__name">
                                  {pd.friendly_name}
                                </td>
                                <td>
                                  {pd.prep_area === 'general'
                                    ? 'Front of House'
                                    : 'Kitchen'}
                                </td>
                                <td>
                                  {pd.connected
                                    ? decodeURI(pd.status)
                                    : 'Discovering...'}
                                </td>
                                <td>
                                  <EditButton
                                    onClick={() =>
                                      this.setState({ printerToEdit: pd })
                                    }
                                    className="printer__edit__cta"
                                  />
                                  <Button
                                    className="fatsoma__cta test__print__cta"
                                    onClick={() => this.createTestPrint(pd._id)}
                                  >
                                    Test Print
                                  </Button>
                                </td>
                              </tr>
                              <tr className={`fold`}></tr>
                            </React.Fragment>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}

                <AddButton
                  onClick={() => this.setState({ addingPrinter: true })}
                >
                  Add a Printer
                </AddButton>

                <Loader
                  loading={
                    this.state.fetchingPrinters ||
                    this.state.creatingTestPrintJob
                  }
                />
              </div>
            )}

            <Loader
              text={
                this.state.printingEnabledToggleValue ? 'Enabling' : 'Disabling'
              }
              loading={this.props.updatingVenue}
            />
          </div>

          <h2 className="panel__title">Tip Controls</h2>
          <div
            className="settings__section settings__section__padding__sm"
            style={{ position: 'relative' }}
          >
            <div style={{ paddingBottom: '12px', paddingTop: '20px' }}>
              <FieldLabel style={{ marginTop: '20px' }}>
                Turn on tips
              </FieldLabel>
            </div>
            <Field
              name="tips_enabled"
              component={Checkbox}
              label="Enable tips for customers"
              isChecked={this.props.formValues.tips_enabled}
              onSelect={() => {
                const toggle = !this.props.formValues.tips_enabled;
                this.props.changeFormField(
                  'venue-settings',
                  'tips_enabled',
                  toggle
                );
              }}
              className="form__selector"
              tall={true}
              style={{ fontSize: '13px', height: '35px' }}
            />

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '20px',
                marginTop: '25px',
              }}
            >
              <div>
                <FieldDropdownLabel style={{ marginTop: '0px' }}>
                  Option 1
                </FieldDropdownLabel>
                <div style={{ width: 'auto' }}>
                  <Field
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">%</InputAdornment>
                      ),
                    }}
                    inputProps={{
                      step: '1',
                      min: '0',
                    }}
                    name="tip_option_1"
                    placeholder="0"
                    type="number"
                    margin="normal"
                    variant="outlined"
                    component={FormTextField}
                    normalize={value =>
                      value ? value.replace(/[^\d]/g, '') : ''
                    }
                  />
                </div>
              </div>

              <div>
                <FieldDropdownLabel style={{ marginTop: '0px' }}>
                  Option 2
                </FieldDropdownLabel>
                <div style={{ width: 'auto' }}>
                  <Field
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">%</InputAdornment>
                      ),
                    }}
                    inputProps={{
                      step: '1',
                      min: '0',
                    }}
                    name="tip_option_2"
                    placeholder="0"
                    type="number"
                    margin="normal"
                    variant="outlined"
                    component={FormTextField}
                    normalize={value =>
                      value ? value.replace(/[^\d]/g, '') : ''
                    }
                  />
                </div>
              </div>

              <div>
                <FieldDropdownLabel style={{ marginTop: '0px' }}>
                  Option 3
                </FieldDropdownLabel>
                <div style={{ width: 'auto' }}>
                  <Field
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">%</InputAdornment>
                      ),
                    }}
                    inputProps={{
                      step: '1',
                      min: '0',
                    }}
                    name="tip_option_3"
                    placeholder="0"
                    type="number"
                    margin="normal"
                    variant="outlined"
                    component={FormTextField}
                    normalize={value =>
                      value ? value.replace(/[^\d]/g, '') : ''
                    }
                  />
                </div>
              </div>
            </div>

            <div style={{ marginTop: '25px', marginBottom: '-30px' }}>
              <FieldDropdownLabel>Pre-selected</FieldDropdownLabel>
            </div>
            <div style={{ width: '200px' }}>
              <Field
                name="default_tip_option"
                component={FormSelectField}
                validate={[]}
                fullWidth
              >
                <MenuItem value="0" style={{ fontSize: '13px' }}>
                  No Tip
                </MenuItem>
                <MenuItem value="1" style={{ fontSize: '13px' }}>
                  Option 1
                </MenuItem>
                <MenuItem value="2" style={{ fontSize: '13px' }}>
                  Option 2
                </MenuItem>
                <MenuItem value="3" style={{ fontSize: '13px' }}>
                  Option 3
                </MenuItem>
              </Field>
            </div>

            <div style={{ paddingTop: '30px' }}>
              <FieldLabel style={{ marginTop: '0px' }}>Tip Message</FieldLabel>
              <Field
                name="tip_message"
                placeholder="100% of the tips go to the service team"
                fullWidth
                type="text"
                margin="normal"
                component={FormTextField}
              />
            </div>
          </div>
        </div>

        <StickyFooter>
          <FormSubmitButton
            onClick={this.submit}
            className="fatsoma__cta"
            loading={this.props.updatingVenue}
          >
            Update
          </FormSubmitButton>
        </StickyFooter>

        {addingPrinter && (
          <AddPrinterDialog
            onPrinterAdded={() => {
              this.setState({ addingPrinter: false });
              this.fetchPrintDevices();
            }}
            locked={true}
            open={true}
            onClose={() => this.setState({ addingPrinter: false })}
            showAlert={this.props.showAlert}
            venueId={this.props.venue._id}
          />
        )}
        {printerToEdit && (
          <EditPrinterDialog
            onUpdated={() => {
              this.setState({ printerToEdit: null });
              this.fetchPrintDevices();
            }}
            open={true}
            onClose={() => this.setState({ printerToEdit: null })}
            showAlert={this.props.showAlert}
            printer={printerToEdit}
          />
        )}

        {showReceiptSettings && (
          <ReceiptSettingsDialog
            locked={true}
            open={true}
            onSettingsSaved={() => {
              this.setState({ showReceiptSettings: false });
              window.location.reload();
            }}
            onClose={() => this.setState({ showReceiptSettings: false })}
            showAlert={this.props.showAlert}
            venue={this.props.venue}
          />
        )}

        <Pusher
          channel={`${this.props.venue._id}`}
          event="printer-update"
          onUpdate={() => this.fetchPrintDevices()}
        />
      </React.Fragment>
    );
  }

  componentWillUpdate(nextProps, nextState) {
    const printStatusUpdate = this.state.updatingPrintStatus;

    if (
      !printStatusUpdate &&
      !nextProps.updatingVenue &&
      this.props.updatingVenue
    ) {
      if (nextProps.venueUpdated) {
        this.props.showAlert(
          'Success',
          'You have successfully changed the venues details.'
        );
      } else {
        this.props.showAlert(
          'Failure',
          'Sorry, we could not update the venue. Please try again later.'
        );
      }
    }

    if (
      printStatusUpdate &&
      !nextProps.updatingVenue &&
      this.props.updatingVenue
    ) {
      if (!nextProps.venueUpdated) {
        this.setState({
          printingEnabledToggleValue: !this.state.printingEnabledToggleValue,
        });
      }
    }
  }

  // Pagination

  changeTab = (event, tabPage) => this.setState({ tabPage });

  submit = () => {
    window.Intercom('trackEvent', 'update-venue-settings');

    let formData = this.props.formValues;
    const { uploadedImageURL } = this.props;

    if (uploadedImageURL && uploadedImageURL !== '') {
      formData['image_url'] = uploadedImageURL;
    }

    if (formData['fee']) {
      formData['fee'] = parseFloat(formData['fee']);
    }

    // Convert tip fields to numbers
    if (formData.tip_option_1 != null)
      formData['tip_option_1'] = Number(formData['tip_option_1']);
    if (formData.tip_option_2 != null)
      formData['tip_option_2'] = Number(formData['tip_option_2']);
    if (formData.tip_option_3 != null)
      formData['tip_option_3'] = Number(formData['tip_option_3']);
    if (formData.default_tip_option != null)
      formData['default_tip_option'] = Number(formData['default_tip_option']);

    if (this.props.auth.role !== 'admin') {
      delete formData['fee'];
    }

    this.props.updateVenue(formData);
  };

  onChangeFile = event => {
    event.stopPropagation();
    event.preventDefault();

    const fileReader = new FileReader();
    const file = event.target.files[0];

    fileReader.onload = () => {
      this.setState({ venueImageSrc: fileReader.result });
      this.props.uploadVenueImage(fileReader.result);
    };

    fileReader.onerror = () => {
      fileReader.abort();
    };

    doka.edit(file).then(output => {
      fileReader.readAsDataURL(output.file);
    });
  };
}

const mapStateToProps = state => ({
  formValues: getFormValues('venue-settings')(state) || {},
  auth: state.authentication,
  venue: state.venue,
  fetchingVenue: state.venue.fetchingVenue,
  updatingVenue: state.venue.updatingVenue,
  venueUpdated: state.venue.venueUpdated,
  fetchingManagedPages: state.venue.fetchingManagedPages,
  managedPages: state.venue.managedPages,
  managedPagesQueryable: state.venue.managedPagesQueryable,
  fetchingFatsomaPage: state.venue.fetchingFatsomaPage,
  fatsomaPage: state.venue.fatsomaPage,
  fatsomaPageId: state.venue.fatsoma_page_id,

  fatsomaPageConnected:
    state.venue.fatsoma_page_id && state.venue.fatsoma_page_id !== '',
  role: state.authentication.role,
  uploadedImageURL: state.venue.uploadedImageURL,
  uploadingImage: state.venue.uploadingImage,
  venueImageUrl: state.venue.image_url,
  printingEnabled: state.venue.printing_enabled || false,
  url_slug: state.venue.url_slug,
  initialValues: {
    service_type: state.venue.service_type || 'table_collection',
    fee: state.venue.fee,
    name: state.venue.name,
    description: state.venue.description,
    customer_service_fee_percent: state.venue.customer_service_fee_percent || 0,
    offset_fee_to_customer: state.venue.offset_fee_to_customer || false,
    accept_preorders: state.venue.accept_preorders || false,
    payment_tier: state.venue.payment_tier || 'basic_paid',
    support_email: state.venue.support_email || '',
    support_phone: state.venue.support_phone || '',
    currency: state.venue.currency || 'GBP',
    url_slug: state.venue.url_slug,
    sms_notifications: state.venue.sms_notifications,
    iqos_friendly: state.venue.iqos_friendly,
    pending_fomo_hours: state.venue.pending_fomo_hours || 48,
    staff_names: state.venue.staff_names || [],
    twitter_username: state.venue.twitter_username || '',
    facebook_username: state.venue.facebook_username || '',
    instagram_username: state.venue.instagram_username || '',
    weekly_report_emails: state.venue.weekly_report_emails || [],
    multi_venue_enabled: state.venue.multi_venue_enabled || false,
    enable_vat: state.venue.enable_vat || false,
    vat_number: state.venue.vat_number || '',
    registered_business_name: state.venue.registered_business_name || '',
    registered_business_address: state.venue.registered_business_address || '',
    clients_enabled: state.venue.clients_enabled || false,
    location: state.venue.location || {},
    emails: sanitizeEmails(state.venue.emails) || {
      confirmation: { content_html: '' },
    },
    tips_enabled: state.venue.tips_enabled || false,
    default_tip_option: state.venue.default_tip_option || 0,
    tip_message:
      state.venue.tip_message || '100% of the tips go to the service team',
    tip_option_1: state.venue.tip_option_1 || 0,
    tip_option_2: state.venue.tip_option_2 || 0,
    tip_option_3: state.venue.tip_option_3 || 0,
  },
});
const sanitizeEmails = emails => {
  if (emails == null) {
    return { content_html: '' };
  }

  var confirmation = emails['confirmation'] || { content_html: '' };
  confirmation.content_html = confirmation.content_html.replace(
    /<br\s*[/]?>/gi,
    '\n'
  );

  return { ...emails, confirmation };
};

const mapDispatchToProps = dispatch => ({
  updateVenue: data => dispatch(updateVenue(data)),
  uploadVenueImage: data => dispatch(uploadVenueImage(data)),
  changeFormField: (formName, fieldName, newValue) =>
    dispatch(change(formName, fieldName, newValue)),
  showAlert: (title, message, callback) =>
    dispatch(showAlert(title, message, callback)),
  fetchManagedPages: data => dispatch(fetchManagedPages(data)),
  fetchFatsomaPage: data => dispatch(fetchFatsomaPage(data)),
});

SettingsPanel = reduxForm({
  form: 'venue-settings',
  destroyOnUnmount: true,
  enableReinitialize: true,
  forceUnregisterOnUnmount: true,
})(SettingsPanel);

export default connect(mapStateToProps, mapDispatchToProps)(SettingsPanel);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Settings/index.jsx